import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { DivisionAddEditComponent, DivisionListComponent } from '@user/components/division';
import { DynamicDialogModule } from 'primeng/components/dynamicdialog/dynamicdialog';

import { MatButtonModule, MatDialogModule, MatIconModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  { path: '', component: DivisionListComponent, canActivate: [AuthGuard], data: { title: 'Division' } }
];
@NgModule({
  declarations: [DivisionAddEditComponent, DivisionListComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MatIconModule, MatDialogModule, MatButtonModule,
    SharedModule,
    DynamicDialogModule
  ],
  entryComponents: [DivisionAddEditComponent]
})
export class DivisionModule { }